import React from "react";
import PropTypes from 'prop-types';
import { CheckboxControl } from '@wordpress/components';

import Base from "../Base";
import withInput from "../../../hoc/withInput";

class CheckboxInput extends Base {
	onChange( value ) {
		const { id, updateOption, inputValue } = this.props;
		const valueIndex = inputValue.indexOf( value );

		if ( valueIndex === -1 ) {
			updateOption( id, [...inputValue, value] );
		} else {
			updateOption( id, [...inputValue.slice( 0, valueIndex ), ...inputValue.slice( valueIndex + 1 )] );
		}

	}
	input() {
		const { inputValue, options } = this.props;
		
		return(
			<div>
				{
					Object.keys( options ).map( ( optionId ) => (
						<CheckboxControl key={ optionId } label={ options[ optionId ] } checked={ inputValue.indexOf( optionId ) !== -1 } onChange={ () => {
							this.onChange( optionId );
						} } />
					) )
				}
			</div>
		);
	}
}


CheckboxInput.propTypes = {
	inputValue: PropTypes.array,
};

export default withInput( CheckboxInput );
